/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { CreatedByDto } from "./CreatedByDto.ts"
import type { DocumentDto } from "./DocumentDto.ts"

export const findIngestionsResponseDtoStatusEnum = {
  PENDING: "PENDING",
  BLANK_PRODUCTS_VERIFIED: "BLANK_PRODUCTS_VERIFIED",
  BLANK_PRODUCTS_INGESTED: "BLANK_PRODUCTS_INGESTED",
  PRODUCTS_VERIFIED: "PRODUCTS_VERIFIED",
  PRODUCTS_INGESTED: "PRODUCTS_INGESTED",
  PROCESSED: "PROCESSED",
  ERROR: "ERROR",
  FAILED: "FAILED",
  PRODUCTS_PRE_VERIFIED: "PRODUCTS_PRE_VERIFIED",
  BUSINESS_PARTNER_VERIFIED: "BUSINESS_PARTNER_VERIFIED",
  BUSINESS_PARTNER_INGESTED: "BUSINESS_PARTNER_INGESTED",
} as const

export type FindIngestionsResponseDtoStatusEnumKey =
  (typeof findIngestionsResponseDtoStatusEnum)[keyof typeof findIngestionsResponseDtoStatusEnum]

export const findIngestionsResponseDtoStepEnum = {
  VERIFY_BLANK_PRODUCTS: "VERIFY_BLANK_PRODUCTS",
  INGEST_BLANK_PRODUCTS: "INGEST_BLANK_PRODUCTS",
  VERIFY_PRODUCTS: "VERIFY_PRODUCTS",
  INGEST_PRODUCTS: "INGEST_PRODUCTS",
  LAUNCH_TRACEABILITY: "LAUNCH_TRACEABILITY",
} as const

export type FindIngestionsResponseDtoStepEnumKey =
  (typeof findIngestionsResponseDtoStepEnum)[keyof typeof findIngestionsResponseDtoStepEnum]

export const findIngestionsResponseDtoTypeEnum = {
  PRODUCT: "PRODUCT",
  BUSINESS_PARTNER: "BUSINESS_PARTNER",
} as const

export type FindIngestionsResponseDtoTypeEnumKey =
  (typeof findIngestionsResponseDtoTypeEnum)[keyof typeof findIngestionsResponseDtoTypeEnum]

export type FindIngestionsResponseDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type string, date-time
   */
  createdAt: Date
  /**
   * @type string
   */
  status: FindIngestionsResponseDtoStatusEnumKey
  /**
   * @type object
   */
  document: DocumentDto
  createdBy: CreatedByDto | null
  /**
   * @type number
   */
  product_count: number
  /**
   * @type string, date-time
   */
  traceabilityLaunchedAt?: Date | null
  /**
   * @type string
   */
  step?: FindIngestionsResponseDtoStepEnumKey | null
  /**
   * @type boolean
   */
  isTraceabilityLaunched: boolean
  /**
   * @type string
   */
  type: FindIngestionsResponseDtoTypeEnumKey
}
